<template>
	<div
		class="task task--child"
		:class="{'task--owned':userIsOwner}">
		<div
			class="task__cell task__done"
			:class="{'task__done--due':due}"
			v-if="userIsOwner">
			<i v-if="childTask.Info.done" class="far fa-check-circle" @click="toggleTask(!childTask.Info.done)"></i>
			<i v-else class="far fa-circle"	@click="toggleTask(!childTask.Info.done)"></i>
		</div>
		<div class="task__cell task__type">
			{{childTask.type}}
		</div>
		<div class="task__cell task__description">
			{{childTask.description}}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		childTask: Object,
		planningId: Number
	},
	data () {
		return {
		}
	},
	methods: {
		async toggleTask (done) {
			// Check if task should be toggled
			if (!this.userIsOwner) return
			// Dispatch toggleTask action so the store's data is updated
			this.$store.dispatch('toggleTask', {
				planningId: this.planningId,
				taskId: this.childTask.id,
				done,
				parent: this.childTask.parent
			})
		}
	},
	computed: {
		planning () {
			const index = this.$store.state.plannings.findIndex(planning => planning.id === this.planningId)
			return this.$store.state.plannings[index]
		},
		userIsOwner () {
			if (!this.planning) return false
			return this.planning.User.id === this.$store.state.authentication.user.id
		},
		due () {
			const date = new Date()
			return !this.childTask.Info.done && (new Date(this.childTask.Info.date) < date)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_task.scss"
</style>
